import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const numberConfigValidatorSchema = {
    decimalSeparator: nonEmptyStringValidator,
    decimalPrecision: Validator.number({ min: 0 }),
    thousandsSeparator: nonEmptyStringValidator,
    nonNumberPlaceholder: Validator.string()
};
export const numberConfigValidator = Validator.object(numberConfigValidatorSchema);
